import React from "react";

const RecipesTent = ({ handleRedirect, tentSingle, arrow }) => {
  return (
    <>
      <div className="tent-wrapper recipes-tent-wrapper">
        <img src={tentSingle} alt="" />
      </div>
      <div
        className="inside-tent-door-wrapper recipes-tent-door-wrapper"
        onClick={() => {
          handleRedirect("/recipes");
        }}
      >
        <img src={arrow} alt="" className="arrow-icon" />
      </div>
      <div className="recipes-tent-text-wrapper"></div>
    </>
  );
};

export default RecipesTent;
